$(function() {
    $('.breadcrumb li, .page-header-title, title, .collection-thumb-title, .category-filters-area-list [data-collection-title], .category-product-sorting-total b').each(function( index ) {
        let text = $(this).text();
        text = text.trim().replace(/^((?:[0-9]\.?)*)([^0-9].+)$/, "$2");
        $(this).html(text);
    });
    if($('#smoothie-job-content .job-list-filters').length > 0) {
        $('#smoothie-job-content .job-list-filters a').on('click', function(event){
            event.preventDefault();
            $('#smoothie-job-content .job-list-filters li').removeClass('active');
            $(this).parent('li').addClass('active');
            let filter = $(this).attr('data-filter');
            if(filter != 'all') {
                $('#smoothie-job-content .job-listing li').each(function(){
                    let location = $(this).attr('data-location');
                    if(filter != location){
                        $(this).hide();
                    } else {
                        $(this).show();
                    }
                });
            } else {
                $('#smoothie-job-content .job-listing li').show();
            }
        });
    }

    if ($('.hunting-permit-form').length > 0) {
        $('#date-de-naissance').dateDropdowns({
            submitFormat:'yyyy-mm-dd',
            daySuffixes:false,
            monthSuffixes:false,
            monthFormat: 'short',
            monthShortValues: ['01','02','03','04','05','06','07','08','09','10','11','12'],
            dayLabel:'DD',
            monthLabel:'MM',
            yearLabel:'YYYY',
            displayFormat:'ymd',
            minAge: 18,
            maxAge: 100
        });
        $('#date-dexpiration').dateDropdowns({
            submitFormat:'yyyy-mm-dd',
            daySuffixes:false,
            monthSuffixes:false,
            monthFormat: 'short',
            monthShortValues: ['01','02','03','04','05','06','07','08','09','10','11','12'],
            dayLabel:'DD',
            monthLabel:'MM',
            yearLabel:'YYYY',
            displayFormat:'ymd',
            minAge: -20,
            maxAge: -1
        });

        let typePermis = $('#type-de-permis').attr('data-val');
        if (typePermis != undefined && typePermis != '') {
            $('#type-de-permis option[value="'+typePermis+'"]').prop('selected','selected');
        }
    }
});